import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useParams } from 'react-router';

import { useGetCourse } from 'api/hooks/private/courses/GetCourse';

import { PageContainer } from 'components/PageContainer';

import useSearchParamState from 'hooks/useSearchParamState';

import CourseSettingsMenu from './components/CourseSettingsMenu';
import CourseInstructorList from './Tabs/CourseInstructorList';
import CourseSectionsList from './Tabs/CourseSectionList';
import CourseTerms from './Tabs/CourseTerms';

type CourseTabs = 'sections' | 'instructors' | 'terms';

export function ManageCourse() {
  // get the course id
  const { id } = useParams<{ id: string }>();
  const [tabValue, setTabValue] = useSearchParamState({
    paramName: 'tab',
    initialState: 'sections',
    serialize: String,
    deserialize: String,
  });

  // fetch the course
  const course = useGetCourse({
    variables: {
      id: id ?? '',
    },
    enabled: !!id,
  });

  const handleSetTabValue = (_event: React.SyntheticEvent, newValue: CourseTabs) => {
    setTabValue(newValue);
  };

  return (
    <PageContainer
      title={course.data?.title}
      slotProps={{
        header: {
          slots: {
            toolbar: () => <CourseSettingsMenu courseId={id ?? ''} />,
          },
        },
      }}
    >
      <Tabs
        value={tabValue}
        onChange={handleSetTabValue}
        sx={{
          background: 'transparent',
          ml: -2,
          marginBottom: 2,
        }}
      >
        <Tab value="sections" label="Sections" />
        <Tab value="instructors" label="Instructors" />
        {/* <Tab value="terms" label="Course Terms" /> */}
      </Tabs>

      {id && tabValue === 'sections' && <CourseSectionsList courseId={id} />}
      {id && tabValue === 'instructors' && <CourseInstructorList courseId={id} />}
      {id && tabValue === 'terms' && <CourseTerms courseId={id} />}
    </PageContainer>
  );
}

export default ManageCourse;
